import React from 'react';
import {useNavigate} from 'react-router-dom';
import { Button } from 'antd';

import { REFUND_FREE} from '../../../../config/routes';

import cls from '../Success/Success.module.scss'


export const ErrorFio = () => {

    const navigate = useNavigate()

    return (
    <div className={cls.page}>
        <div className={'content'}>
            <div className={cls.text}>
                <h2>Ошибка банковских реквизитов</h2>
                <p>
                    Уважаемый Клиент,<br/>
                    Группа компаний «FTS Group» благодарит Вас за обращение.
                </p>
                <p>
                    В рамках исполнения 115-ФЗ «О противодействии легализации (отмыванию) доходов, полученных преступным путем, и финансированию терроризма» перечисления денежных средств должно производиться на реквизиты физического лица, которое указано в сертификате как Клиент.
                </p>
                <p>
                    Просьба указать реквизиты владельца сертификата.
                </p>
                <Button type={'primary'} size={'large'} onClick={() => navigate(REFUND_FREE)}>Хорошо</Button>
            </div>
        </div>

    </div>
)}


